export default __webpack_public_path__ + "static/media/close.e97d10b4.svg";